export default "__VITE_ASSET__D6Or9DxR__"